<template>
  <modal name="selectRecord" transition="nice-modal-fade" :pivotY="0.3">
    <div class="select-record">
      <div class="title">
        <div class="close-button" @click="close">
          <i></i>
        </div>
      </div>
      <div class="content">
        <div>我们将在录音时同步播放视频画面以辅助您录音,请选择你是打算为那些页面录音?</div>
      </div>
      <div class="button-content">
        <div class="button-select">
          <el-button type="primary" @click="recordStart('select')">仅为当前页面录音</el-button>
          <div>录音时从当前页面播放画面,最长可录制30秒</div>
        </div>
        <div class="button-primary">
          <el-button type="primary" @click="recordStart('all')">为整个视频录音</el-button>
          <div>录音时从第0秒播放画面,最长可录制6分钟</div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "selectRecord",
  computed: {
    ...mapGetters(["TOOL"])
  },
  data() {
    return {
      ANALYSIS: {
        select: {
          category: "recording_classification",
          action: "click_start_recording_for_scene",
          label: "录音_为当前页面录音"
        },
        all: {
          category: "recording_classification",
          action: "click_start_recording_for_video",
          label: "录音_为整个视频录音"
        }
      }
    };
  },
  mounted() {},
  methods: {
    recordStart(type) {
      this.$bus.emit("stop_listen_BGM");
      // 画布恢复正常大小
      if (this.TOOL.option.scale !== 1) {
        this.TOOL.setOption({
          width: this.Tool_Size.width,
          height: this.Tool_Size.height - 40,
          scale: 1,
          surplusY: this.TopNav_Size.height + 40,
          surplusX: this.MaterialPane_Size.width
        });
      }
      this.$bus.emit("Modal_vue", {
        name: "preview",
        data: {
          type: "record",
          select: type
        }
      });
      this.$modal.hide("selectRecord");
      this.$analysis(this.ANALYSIS[type]);
    },
    close() {
      this.$modal.hide("selectRecord");
    }
  }
};
</script>

<style lang="scss" scoped>
.select-record {
  position: relative;
  width: 525px;
  height: 245px;
  background: #fff;
  border-radius: 3px;
}
.title {
  height: 66px;
}
div.close-button {
  position: absolute;
  right: 11px;
  top: 7px;
  width: 16px;
  cursor: pointer;
}
i {
  position: relative;
  left: 7px;
  top: 2px;
  width: 2px;
  height: 15px;
  border-radius: 3px;
  background: #737596;
  transform: rotate(45deg);
  display: inline-block;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 2px;
    height: 15px;
    border-radius: 3px;
    background: #737596;
    transform: rotate(270deg);
  }
}
.content {
  text-align: center;
  font-size: 13px;
  color: #666;
}
.button-content {
  display: flex;
  justify-content: space-between;
  margin: 40px 60px;

  > div {
    text-align: center;

    div {
      margin-top: 10px;
      width: 150px;
      line-height: 1.6;
      color: #bbb;
      font-size: 13px;
    }
  }

  button {
    height: 38px;
    padding-top: 12px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/emodal/record/selectRecord.vue